import AddIcon from '@mui/icons-material/Add'
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { FC, useState } from 'react'
import { connect } from 'react-redux'
import {
  DiscountTierPropsType,
  DiscountTierType,
  MarkupPropsType,
  MarkupType,
} from '../../../api/appAPI'
import { StateType } from '../../../redux/store'
import { EnqueueSnackbarType } from '../../common/Helpers'

import {
  addDiscountTier,
  deleteDiscountTier,
  editDiscountTier,
} from '../../../redux/appReducer'
import DefineDiscountTier from './DefineDiscountTier'
import EditDiscountTier from './EditDiscountTier'

interface IProps {
  dTiers: DiscountTierType[]

  addDiscountTier(
    tierProps: DiscountTierPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): void
  editDiscountTier(
    id: number,
    tierProps: DiscountTierPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): void
  deleteDiscountTier(id: number, enqueueSnackbar: EnqueueSnackbarType): void
}

const DiscountTiers: FC<IProps> = (props) => {
  const [activeTier, setActiveTier] = useState<undefined | DiscountTierType>(
    undefined
  )

  return (
    <Box display="flex" style={{ height: window.innerHeight - 48 * 2 }}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        pt={2}
        style={{ borderRight: 'solid 1px black', width: '50%' }}
      >
        <Typography variant="h6">Discount Tier List</Typography>

        <Paper style={{ width: '90%', maxHeight: '90%', overflowY: 'auto' }}>
          <List component="nav" style={{ padding: 0 }}>
            <ListItem
              button
              onClick={() => {
                // props.setActiveMaterialId(0)
                setActiveTier(undefined)
              }}
            >
              <ListItemText primary="New Discount Tier" />
              <AddIcon />
            </ListItem>
            <Divider />
          </List>
        </Paper>
        <DataGrid
          style={{ width: '90%', maxHeight: '90%', overflowY: 'auto' }}
          columns={[
            { field: 'id' },
            { field: 'name', headerName: 'Name', minWidth: 200 },
            {
              field: 'extraDiscountStartPoint',
              headerName: 'Extra Discount Start Point',
              type: 'number',
              width: 200,
            },
            {
              field: 'DPA_OfferCabinets',
              headerName: 'DPA Offer Cabinets',
              minWidth: 200,
            },
            {
              field: 'PPFD_OfferCabinets',
              headerName: 'PPFD Offer Cabinets',
              minWidth: 200,
            },
            {
              field: 'DPA_OfferSlatwallAndAcc',
              headerName: 'DPA OfferSlatwall And Acc',
              minWidth: 200,
            },
            {
              field: 'PPFD_OfferSlatwallAndAcc',
              headerName: 'PPFD Offer Slatwall And Acc',
              minWidth: 200,
            },
            {
              field: 'DPA_OfferOverheadStorage',
              headerName: 'DPA Offer Overhead Storage',
              minWidth: 200,
            },
            {
              field: 'PPFD_OfferOverheadStorage',
              headerName: 'PPFD Offer Overhead Storage',
              minWidth: 200,
            },
          ]}
          // hideFooterPagination
          rows={props.dTiers.map((t) => ({
            id: t.id,
            name: t.name,
            extraDiscountStartPoint: t.extraDiscountStartPoint,
            DPA_OfferCabinets: t.DPA_OfferCabinets.join(','),
            PPFD_OfferCabinets: t.PPFD_OfferCabinets.join(','),
            DPA_OfferSlatwallAndAcc: t.DPA_OfferSlatwallAndAcc.join(','),
            PPFD_OfferSlatwallAndAcc: t.PPFD_OfferSlatwallAndAcc.join(','),
            DPA_OfferOverheadStorage: t.DPA_OfferOverheadStorage.join(','),
            PPFD_OfferOverheadStorage: t.PPFD_OfferOverheadStorage.join(','),
          }))}
          onRowClick={(param) => {
            setActiveTier(
              props.dTiers.find((m) => m.id === parseInt(param.id.toString()))
            )
          }}
        />
      </Box>
      {activeTier === undefined ? (
        <DefineDiscountTier addTier={props.addDiscountTier} />
      ) : (
        <EditDiscountTier tier={activeTier} editTier={props.editDiscountTier} />
      )}
    </Box>
  )
}

const mapStateToProps = (state: StateType) => ({
  dTiers: state.appReducer.discountTiersList,
})

export default connect(mapStateToProps, {
  addDiscountTier,
  editDiscountTier,
  deleteDiscountTier,
})(DiscountTiers)
